/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { setHeader } from "../../shared/helpers";

// Import all icons statically
import toolkitIcon from "../../../assets/icons/toolkit_light20@3x.png";
import customerIcon from "../../../assets/icons/customer_light20@3x.png";
import homeIcon from "../../../assets/icons/home_light20@3x.png";
import listIcon from "../../../assets/icons/list_light20@3x.png";
import lockIcon from "../../../assets/icons/lock_light20@3x.png";
import gearIcon from "../../../assets/icons/gear_light20@3x.png";

// Create icon mapping
const iconMap = {
  "toolkit_light20@3x.png": toolkitIcon,
  "customer_light20@3x.png": customerIcon,
  "home_light20@3x.png": homeIcon,
  "list_light20@3x.png": listIcon,
  "lock_light20@3x.png": lockIcon,
  "gear_light20@3x.png": gearIcon,
};

function Submenu(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { data } = props;
  const accordion = useRef(null);
  const [isOpen, setIsOpen] = useState(() => {
    // Initialize based on current path
    return location.pathname.startsWith("/tools/");
  });

  useEffect(() => {
    // Check if current path is within the Tools section
    const isToolsPath = location.pathname.startsWith("/tools/");

    if (isToolsPath) {
      // If navigating to Tools section, always open it
      setIsOpen(true);
    } else {
      // If navigating away from Tools section, close it
      setIsOpen(false);
    }
  }, [location.pathname]);

  return (
    <Accordion activeKey={isOpen ? "0" : ""}>
      <Accordion.Item eventKey="0">
        <Accordion.Header
          as="div"
          onClick={() => setIsOpen((prev) => !prev)}
          ref={accordion}
        >
          <a
            className="nav-link text-light50 d-flex align-items-center"
            id="tools_route"
            style={{
              fontWeight: "bold",
              textDecoration: "none",
            }}
          >
            {data.icon && iconMap[data.icon] ? (
              <img
                src={iconMap[data.icon]}
                alt="icon"
                style={{
                  width: "16px",
                  height: "16px",
                  marginRight: "14px",
                }}
              />
            ) : null}
            {data.name}
          </a>
        </Accordion.Header>

        <Accordion.Body style={{ padding: "0 16px 15px 16px" }}>
          {data.childrens?.map((child, i) => (
            <NavLink
              key={`sub-menu-${i}`}
              id={child.name}
              to={data.path + child.to}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              style={({ isActive }) => ({
                color: isActive ? "#2F481E" : "#84857a",
                backgroundColor: isActive ? "#E7F3E7" : "transparent",
              })}
              onClick={() => {
                setHeader(dispatch, {
                  title: child.name,
                  previousPath: "",
                  icon: data.icon,
                });
              }}
            >
              {child.name}
            </NavLink>
          ))}
          <hr
            style={{
              width: "80%",
              margin: "1rem auto 1rem auto",
              borderWidth: "1px",
            }}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default Submenu;
